import React, { useEffect } from 'react';
import { useAuth } from '../App';

export default function ThankYou() {
  const { navigate } = useAuth();

  // This is where Google Ads conversion tracking would fire
  useEffect(() => {
    // Google Ads Conversion Tracking
    // Replace with your actual conversion ID and label
    if (typeof gtag !== 'undefined') {
      gtag('event', 'conversion', {
        'send_to': 'AW-XXXXXXXXX/XXXXXXXXXXXX',
        'value': 1.0,
        'currency': 'USD'
      });
    }
    
    // You can also add Facebook Pixel, etc.
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Lead');
    }
  }, []);

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4">
      <div className="max-w-2xl text-center">
        {/* Success Icon */}
        <div className="w-24 h-24 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-8 animate-fade-in">
          <svg className="w-12 h-12 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="font-serif text-4xl md:text-5xl text-navy-900 mb-6 animate-fade-in stagger-1">
          Thank You!
        </h1>
        
        <p className="text-xl text-navy-600 mb-4 animate-fade-in stagger-2">
          Your request has been received.
        </p>
        
        <p className="text-navy-500 mb-8 animate-fade-in stagger-3">
          One of our certified luxury travel advisors will reach out to you 
          within the next 24 hours to discuss your dream trip.
        </p>

        <div className="bg-cream-50 rounded-lg p-6 mb-8 animate-fade-in stagger-4">
          <h2 className="font-serif text-lg text-navy-900 mb-3">What happens next?</h2>
          <ol className="text-left text-navy-600 space-y-3">
            <li className="flex items-start">
              <span className="w-6 h-6 bg-gold-500 text-white rounded-full flex items-center justify-center text-sm font-medium mr-3 flex-shrink-0 mt-0.5">1</span>
              <span>Check your email for a confirmation of your request</span>
            </li>
            <li className="flex items-start">
              <span className="w-6 h-6 bg-gold-500 text-white rounded-full flex items-center justify-center text-sm font-medium mr-3 flex-shrink-0 mt-0.5">2</span>
              <span>A certified travel advisor will review your trip details</span>
            </li>
            <li className="flex items-start">
              <span className="w-6 h-6 bg-gold-500 text-white rounded-full flex items-center justify-center text-sm font-medium mr-3 flex-shrink-0 mt-0.5">3</span>
              <span>You'll receive a personalized call or email within 24 hours</span>
            </li>
          </ol>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in stagger-5">
          <button onClick={() => navigate('/')} className="btn-secondary">
            Submit Another Request
          </button>
          <a 
            href="https://thediolixacademy.com" 
            className="btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit Our Website
          </a>
        </div>
      </div>
    </div>
  );
}
